export const ADD_ALERT = "addAlert";
export const RESET_ALERTS = "resetAlerts";
